module.exports = __webpack_public_path__ + "img/bio.b269bc8b.jpeg";